import { Coordinate } from '@Utils/Helpers/location/helper';
import { useState, useEffect } from 'react';

const useBrowserLocation = (shouldRun: boolean) => {
  const [position, setPosition] = useState<Coordinate>();

  // Get user's current coordinates
  useEffect(() => {
    if (shouldRun && navigator?.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setPosition({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          //eslint-disable-next-line empty-block
        },
      );
    }
  }, [shouldRun, navigator?.geolocation]);

  return position;
};

export default useBrowserLocation;
